import { render, staticRenderFns } from "./ShipmentItemsList.vue?vue&type=template&id=1c03429a&scoped=true&"
import script from "./ShipmentItemsList.vue?vue&type=script&lang=js&"
export * from "./ShipmentItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c03429a",
  null
  
)

export default component.exports